<div class="pdf-preview-modal">

  <mat-dialog-content>    <div *ngIf="isLoadingPdf" class="pdf-loading-spinner">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      <p>Generando previsualización del PDF...</p>
      <p><small>Se abrirá automáticamente en una nueva pestaña</small></p>
    </div>

    <div *ngIf="errorMessage" class="error-message">
      <div class="alert alert-danger">{{ errorMessage }}</div>
    </div>

    <div class="pdf-container" *ngIf="!isLoadingPdf && pdfUrl && !errorMessage">
      <div class="fallback-message">
        <p>Si el PDF no se abrió automáticamente en una nueva pestaña, puedes verlo aquí:</p>
      </div>
      <object
        [data]="pdfUrl"
        type="application/pdf"
        width="100%"
        height="900">
      </object>
    </div>
  </mat-dialog-content>

</div>
